export default __webpack_public_path__ + "static/media/ford.44c9645d.svg";